import React from "react";
import { Navigate,useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { useState } from "react";
import { changePassword, logout } from "../reducer/Actions";
import hirebeen from '../image/hirebeenLogo.png';
import hide from "../image/icons/hide.png";
import view from "../image/icons/view.png";
import H from '../image/H.png';
import Group1 from '../image/Group1.svg';
import Group2 from '../image/Group2.svg';
import Group3 from '../image/Group3.svg';
import CustomButton from "../Reusable/CustomButton";

const ChangePassword = ({ isAuthenticated, changePassword }) => {
  const navigate = useNavigate()
    const [ formData, setFormData ] = useState ({
        new_password1: "",
        new_password2: "",
        old_password: ""
    });
    const { new_password1, new_password2, old_password } = formData;
    const handlingInput = (e) => setFormData({...formData, [e.target.name]: e.target.value});

    // handle change password
    const handlingSubmit = async (e) => {
        e.preventDefault();
        await changePassword( new_password1, new_password2, old_password )
        const success = await logout();
        if (success) {
            navigate('/');
        }
    }
    if ( !isAuthenticated && !localStorage.getItem('access') ) {
        return <Navigate to={"../login"}></Navigate>
    }
    return (
        <div className="grid grid-cols-2 gap-0 max-md:grid-cols-1">
        <div className="block w-full h-full bg-conic-gradient max-md:hidden">
        <div 
        className="flex gap-2.5 self-start max-md:pr-5 mt-6 ml-6 hover:cursor-pointer"
        onClick={() => navigate("/")}
        >
          <img
            loading="lazy"
            src={H}
            alt="H"
            className="shrink-1 aspect-[0.75] w-[29px]"
          />
          <img
            loading="lazy"
            src={hirebeen}
            alt="logo"
            className="shrink-0 my-auto max-w-full aspect-[5.56] w-[146px]"
          />
        </div>
        <div className=" mx-9 mt-20 text-5xl font-bold text-white leading-[70px] max-md:mt-10 max-md:mr-2.5 max-md:max-w-full max-md:text-4xl max-md:leading-[68px]">
          Build your successful resume instantly using AI
        </div>
        <div className="z-10 self-center mt-3.5 max-w-full w-[574px]">
          <div className="flex gap-1 max-md:flex-col max-md:gap-0">
            <div className="flex flex-col w-11/12 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col mt-16 grow max-md:mt-10">
                <img
                  loading="lazy"
                  src={Group2}
                  alt="group"
                  className="w-full"
                />
                <img
                  loading="lazy"
                  src={Group3}
                  alt="group"
                  className="w-full mt-5"
                />
              </div>
            </div>
            <div className="flex flex-col w-11/12 ml-5 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col max-md:mt-6">
                <img
                  loading="lazy"
                  src={Group1}
                  alt="group"
                  className="w-full "
                />
                <img
                  loading="lazy"
                  src={Group3}
                  alt="group"
                  className="w-full mt-5"
                />
              </div>
            </div>
          </div>
        </div>
        </div>
        <div className="flex flex-col items-center mt-40 rounded max-md:mt-20">
            <h2 className="text-4xl font-semibold leading-10 tracking-tighter text-gray-900 w-80 max-md:mt-4 max-md:max-w-full">Change Password</h2>
            <form className="mt-4 mb-3 w-80" onSubmit={e => handlingSubmit(e)}>
                <div className="mb-3 space-y-0">
                    <label htmlFor="new_password1" className="form-label">New Password</label>
                    <input name="new_password1" value={new_password1} onChange={e => handlingInput(e)} type="password" className="form-control outline-none w-full py-1 px-4 mt-[-10px] border rounded-md mb-4 text-base" id="new_password1" placeholder="Enter new password"/>
                </div>
                <div className="mb-3 space-y-0">
                    <label htmlFor="new_password2" className="form-label">Confirm Password</label>
                    <input name="new_password2" value={new_password2} onChange={e => handlingInput(e)} type="password" className="form-control outline-none w-full py-1 px-4 mt-[-10px] border rounded-md mb-4 text-base" id="new_password2" placeholder="Confirm new password"/>
                </div>
                <div className="mb-3 space-y-0">
                    <label htmlFor="old_password" className="form-label">Old Password</label>
                    <input name="old_password" value={old_password} onChange={e => handlingInput(e)} type="password" className="form-control outline-none w-full py-1 px-4 mt-[-10px] border rounded-md mb-4 text-base" id="old_password" placeholder="Enter old password"/>
                </div>
                <div className="gap-2 d-grid">
                <CustomButton
                    disabled={
                      !formData?.new_password1 ||
                       !formData?.new_password2 ||
                        !formData?.old_password ||
                        formData?.new_password1 !== formData?.new_password2
                      }
                    onClick={handlingSubmit}
                >
                    Change Password
                </CustomButton>
                </div>
            </form>
        </div>
        </div>
    )
}

const mapStateToProps = ( state ) => {
    return {
        isAuthenticated: state.AuthReducer.isAuthenticated
    }
}

export default connect(mapStateToProps, { changePassword })(ChangePassword);